export default {
  install(Vue) {
    Vue.prototype.$copy = function (string) {
      navigator.clipboard.writeText(string);
      try {
        const msg = this.$t("copyNotification");
        const color = "success";
        this.$store.commit("setNotification", {
          msg,
          color,
        });
      } catch (e) {
        console.error(e);
        this.message = "Sorry, unable to copy to clipboard.";
      }
    }
  }
}